import React, { memo } from 'react';

import { addHook, sanitize } from 'dompurify';

interface IProps {
  [key: string]: any;
  html: any;
}

const setAllLinksToOpenInAnotherTab = (): void => {
  addHook('afterSanitizeAttributes', (node: Element): void => {
    if ('target' in node) {
      node!.setAttribute('target', '_blank');
      node!.setAttribute('rel', 'noreferrer');
    }
  });
};

const NoDangerouslyHTML = (props: IProps) => {
  setAllLinksToOpenInAnotherTab();
  return <div {...props} dangerouslySetInnerHTML={{ __html: sanitize(props.html) }} />;
};

export default memo(NoDangerouslyHTML);
